import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { adsServer } from "../../server";

const SponsoredShopsCarouselPropsMobile = ({ ads }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const shopRefs = useRef(new Map()); 

    const logAdClick = async (adId) => {
        try {
            await axios.post(`${adsServer}/sponsored/click/${adId}`, { withCredentials: true, 
                headers: {
                    'current-profile': sessionStorage.getItem('currentProfile') || 'defaultProfile',
                }});
            console.log('Click logged for shop:', adId);
        } catch (error) {
            console.error('Error logging click:', error);
        }
    };


    const logViewedImpression = async (adId) => {
        try {
            await axios.post(`${adsServer}/sponsored/viewed-impression/${adId}`, {}, { withCredentials: true, 
                headers: {
                    'current-profile': sessionStorage.getItem('currentProfile') || 'defaultProfile',
                }});
            console.log('Viewed impression logged for shop:', adId);
        } catch (error) {
            console.error('Error logging viewed impression:', error);
        }
    };

    

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const adId = entry.target.dataset.adId;

                        // Start a timer for 1 second to log viewed impression
                        const timer = setTimeout(() => {
                            logViewedImpression(adId);
                        }, 1000);

                        // Store the timer in the DOM element
                        entry.target._timer = timer;
                    } else {
                        clearTimeout(entry.target._timer); 
                    }
                });
            },
            { threshold: 0.5 } 
        );

        const visibleAds = [ads[currentIndex]];
        if (ads.length > 1) {
            visibleAds.push(ads[(currentIndex + 1) % ads.length]);
        }

        visibleAds.filter(Boolean).forEach((ad) => {
            const shopElement = shopRefs.current.get(ad._id);
            if (shopElement) {
                observer.observe(shopElement);
            }
        });

        return () => {
            observer.disconnect(); 
        };
    }, [currentIndex, ads]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % ads.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + ads.length) % ads.length);
    };

    if (ads.length === 0) {
        return <div className="sponsored-shops-carousel-loading"></div>;
    }

    const visibleAds = [ads[currentIndex]];
    if (ads.length > 1) {
        visibleAds.push(ads[(currentIndex + 1) % ads.length]);
    }

    return (
        <div className="sponsored-shops-carousel-container">
            <>
                <div className="sponsored-shops-carousel-wrapper sponsored-carousel-track">
                    {visibleAds.filter(Boolean).map((ad, index) => (
                        <div
                            key={ad._id}
                            className={`sponsored-shops-carousel-paper-mobile sponsored-carousel-card ${index > 0 ? 'sponsored-carousel-secondary-card' : ''}`}
                            style={{ backgroundImage: `url(${ad.shop.banner?.url})` }}
                            data-ad-id={ad._id}
                            ref={(el) => el && shopRefs.current.set(ad._id, el)}
                        >
                            <ShopItem shop={ad.shop} logAdClick={() => logAdClick(ad._id)} />
                        </div>
                    ))}
                </div>
                {ads.length > 1 && (
                    <>
                        <button className="sponsored-carousel-nav-button sponsored-carousel-prev" onClick={prevSlide}>‹</button>
                        <button className="sponsored-carousel-nav-button sponsored-carousel-next" onClick={nextSlide}>›</button>
                    </>
                )}
            </>
        </div>
    );
};

const ShopItem = ({ shop, logAdClick }) => {
    return (
        <div className="sponsored-shops-carousel-content">
            <img src={shop.avatar?.url} alt={shop.name} className="sponsored-shops-carousel-avatar-mobile" />
            <h2 className="sponsored-shops-carousel-title">{shop.name}</h2>
            <Link
                to={`/shop/${shop.handle}`}
                onClick={logAdClick}
                className="sponsored-shops-carousel-button"
            >
                Visit Store
            </Link>
        </div>
    );
};

export default SponsoredShopsCarouselPropsMobile;